

export const secretFirebase = {
  apiKey: "AIzaSyANOVrE3EgFWlE4xBI1xn_XmheVLAMNrOc",
  authDomain: "gran-kush.firebaseapp.com",
  projectId: "gran-kush",
  storageBucket: "gran-kush.appspot.com",
  messagingSenderId: "248268497160",
  appId: "1:248268497160:web:55c1759b0e73859cdc8cbd",
  measurementId: "G-QSRPJR2EE3"
}





export const firebaseConfig = {
  apiKey: secretFirebase.apiKey,
  authDomain: secretFirebase.authDomain,
  databaseURL: secretFirebase.databaseURL,
  projectId: secretFirebase.projectId,
  storageBucket: secretFirebase.storageBucket,
  messagingSenderId: secretFirebase.messagingSenderId,
  appId: secretFirebase.appId,
  measurementId: secretFirebase.measurementId
};


// const mailKey = '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'
const mKey2 = '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'
const resendKey = 're_41qDHZUj_MLTXDgbn399Rdhn2Gyrv5zpW'